import React from "react";

const NoActivityFound = ({ style }) => {
  return (
    <div className="noActivityFound" style={style}>
      <p className="textDesc">
        No activities found for the selected date range
      </p>
    </div>
  );
};

export default NoActivityFound;
export { NoActivityFound };
